import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { hazletonConfig } from "./data";

export default function HazletonPage() {
  return <CityPageTemplate config={hazletonConfig} />;
}